<template>
  <div
    class="px-4 py-2 shadow-md rounded-md bg-white dark:bg-gray-900 border-2 w-48 text-center transition-colors"
    :class="selected ? 'border-primary-500 ring-2 ring-primary-500/20' : 'border-primary-500'"
  >
    <div class="flex items-center justify-center mb-1">
      <UIcon name="i-heroicons-play-circle" class="w-5 h-5 text-primary-500" />
    </div>
    <div class="font-bold text-gray-900 dark:text-gray-100 text-xs">TRIGGER</div>
    <div v-if="data.objectType" class="text-primary-500 font-bold text-[10px] mt-1 uppercase">
      {{ data.objectType }}
    </div>
    <div class="text-gray-500 dark:text-gray-400 text-[10px]">
      {{ data.type || 'RMQ' }}: {{ data.topic || data.statusId || 'Inbound' }}
    </div>
    <Handle type="source" :position="Position.Bottom" class="w-3 h-3 bg-primary-500" />
  </div>
</template>

<script setup lang="ts">
import { Handle, Position } from '@vue-flow/core'

defineProps<{
  selected?: boolean
  data: {
    type?: string
    topic?: string
    statusId?: string
    objectType?: string
  }
}>()
</script>
